import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  ownership: {
    display: 'flex',
    marginBottom: '1.5em',
    '& > div': {
      width: '33.3333%',
    },
    '& h4': {
      margin: '0 0 0.5em',
      fontSize: '1.125em',
      fontWeight: '400',
    },
    '& p': {
      margin: '0',
      fontSize: '1em',
    },
    '& p:not(:last-child)': {
      marginBottom: '5px',
    },
  },
  grid: {
    display: 'flex',
    '&:nth-child(even)': {
      backgroundColor: theme.custom.gray200,
    },
    '& > div': {
      width: '25%',
      padding: '7px 10px',
    },
  },
}));

const Summary = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.ownership}>
        <div>
          <h4>Owner</h4>
          <p>Joe Owner</p>
          <p>123 Owner st. Owner</p>
          <p>City, Connecticut 84311</p>
          <p>Out-of-State</p>
        </div>
        <div>
          <h4>Owner</h4>
          <p>Joe Owner</p>
          <p>123 Owner st. Owner</p>
          <p>City, Connecticut 84311</p>
          <p>Out-of-State</p>
        </div>
        <div>
          <h4>Owner</h4>
          <p>Joe Owner</p>
          <p>123 Owner st. Owner</p>
          <p>City, Connecticut 84311</p>
          <p>Out-of-State</p>
        </div>
      </div>
      <div>
        <div className={classes.grid}>
          <div>Sold to</div>
          <div>Jill Sold to</div>
          <div>Premise No.</div>
          <div>PREM-ID-1234</div>
        </div>
        <div className={classes.grid}>
          <div>Consigned to</div>
          <div>Jim Consigned to</div>
          <div>Licence No.</div>
          <div>1234 LIC</div>
        </div>
        <div className={classes.grid}>
          <div>Carrier</div>
          <div>New England Trucking</div>
          <div>Registration No.</div>
          <div>REG# 12345</div>
        </div>
        <div className={classes.grid}>
          <div>Destination</div>
          <div>Evanston, WY</div>
          <div>Dealer's Licence No.</div>
          <div>LIC# 123456</div>
        </div>
      </div>
    </>
  );
};

export default Summary;
